import { Box, makeStyles } from '@material-ui/core';
import { WbCardContent } from '../WbCard';
import { WbNoData } from '../WbNoData';
import { WbChip } from '../WbTextField';
import { useMultiSelectionPickerContext } from './MultiSelectionPickerContext';
import { GenericElement } from './types';
import { getOnHoverScrollbarStyle } from '../../styles';

const useStyles = makeStyles(
  theme => ({
    cardContent: {
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    selected: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.5),
      overflow: 'auto',
      height: '100%',
      ...getOnHoverScrollbarStyle(theme, false),
      [theme.breakpoints.down('sm')]: {
        overflow: 'visible',
        height: 'auto',
      },
    },
  }),
  { name: 'SelectedEntities' },
);

interface SelectedEntitiesProps {
  values: GenericElement[];
  setValues: (values: GenericElement[]) => void;
}

export const SelectedValues = ({
  values,
  setValues,
}: SelectedEntitiesProps) => {
  const classes = useStyles();
  const { disableAll, readOnly } = useMultiSelectionPickerContext();
  const handleDelete = (indexToDelete: number) => () => {
    setValues(values.filter((_, index) => index !== indexToDelete));
  };

  const adaptLabel = (option: GenericElement) => {
    const labelKind = option?.kind;
    return `${labelKind ? `${labelKind}:` : ''} ${
      option?.displayName ?? option.name
    }`;
  };

  if (disableAll) {
    return (
      <WbCardContent className={classes.cardContent}>
        <WbChip key="all" label="*All*" style={{ width: 'fit-content' }} />
      </WbCardContent>
    );
  }

  return (
    <WbCardContent className={classes.cardContent}>
      {!values?.length ? (
        <WbNoData
          fillContainer
          header="You haven't made any selection yet."
          text="Select what you need from the list on the left."
        />
      ) : (
        <Box className={classes.selected}>
          {values?.map((e: GenericElement, index: number) => (
            <WbChip
              key={e.id}
              label={adaptLabel(e)}
              onDelete={readOnly ? undefined : handleDelete(index)}
              style={{ width: 'fit-content' }}
            />
          ))}
        </Box>
      )}
    </WbCardContent>
  );
};
